import { useState, useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom'
import { Notifications, Help, ArrowDropDown, Upload, UploadFileOutlined, CloseIcon, CloseRounded, } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Menu,
  MenuItem,
  Avatar,
  Button,
  Badge,
  Box,
  Select,
  Divider,
  Drawer,
  TextField,
  InputLabel,
  FormControl,
  FormControlLabel,
  Checkbox,
  InputAdornment,
Paper,
Tabs,
} from '@mui/material';

import ToggleSplitPane from '../../components/ToggleSplitPane';
import PageLoader from '../../components/PageLoader';
import CaseInformationPane from '../../components/Workflow/CaseInformation';

import {
    TextAreaWithCount,
    sessionService,
    SessionManager,
    ClientType,
    SharedService,
} from '../ComponentsLibrary';
  

const ActionTakenDetails = (props) => {

    const location = useLocation();
    const { row: routeRow, actionTakenData: routeActionTakenData } = location.state || {};
    // When rendered as a popup, row/actionTakenData are passed directly as props;
    // when rendered as a routed page, they come from the navigation state.
    const isPopup = props.row !== undefined;
    const row = isPopup ? (props.row || {}) : (routeRow || {});
    const actionTakenData = isPopup ? (props.actionTakenData || {}) : (routeActionTakenData || {});
    const rowData = {...row, ...actionTakenData}

    useEffect(() => {
      if (!isPopup) {
        document.title = "YTrac :: Action Taken Details";
      }
    }, [isPopup]);

    const caseInfoRef = useRef();

    const leftPaneTitle = "Action Taken Details";
    const rightPaneTitle = "Case Information";

    const formatVarianceTimeDisplay = (value) => {
        if (value === null || value === undefined || value === '') return '';
        const duration = String(value).trim();
        return duration.startsWith('-') ? `(${duration.slice(1)})` : duration;
    };

    const formatVarianceDisplay = (value) => {
        if (value === null || value === undefined || value === '') return '';
        const s = String(value).trim();
        if (s.endsWith('%')) {
            const num = Number(s.replace('%', ''));
            if (!Number.isFinite(num)) return s;
            return `${Math.round(num)}%`;
        }
        const num = Number(s);
        if (Number.isFinite(num)) return `${Math.round(num)}%`;
        return s;
    };


    useEffect(() => {
        if (!caseInfoRef.current) return;
        SessionManager.SetSession(SessionManager.CurrentActivePageKey, ClientType.DropdownCategoryType.Action_Taken_Details);
        const isNoCase = rowData?.caseNumber ? false : true;
        caseInfoRef.current.onSelectCaseFromExternal(rowData?.caseNumber, false, 100, isNoCase, rowData?.caseWorkflowID);   
    }, [rowData]);


    const leftPaneContent = (
        <div className="content-main-container">
            <div className="pane-wrap-container">
            <div className={'pane-main-container'}>
            <div className={'form-section editable'}>{/* 'form-section-2' */}
            <div className={'form-main-container'} style={{height: '100%'}}>{/* 'form-main-container-2' */}
                <div className='form-content'>
                     <div className='form-dynamic-content'>
                        <form className="form-dynamic-grid" style={{backgroundColor: '#0000001a'}}>
                            <div className='form-row' style={{padding: '10px'}}>
                                <div className='form-group'>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                         <FormControl fullWidth>
                                            <Typography id="label" variant="caption" style={{ fontSize: '0.875rem' }}><strong>Action Taken: </strong>{rowData?.lastAction || rowData?.actionTaken}</Typography>
                                        </FormControl>
                                    </div>

                                </div>
                                <div className='form-group'>
                                     <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                         <FormControl fullWidth>
                                            <Typography id="label" variant="caption" style={{ fontSize: '0.875rem' }}><strong>Case ID: </strong>{rowData?.caseNumber}</Typography>
                                        </FormControl>
                                    </div>
                                </div>
                            </div>
                             <div className='form-row' style={{padding: '10px'}}>
                                <div className='form-group'>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                         <FormControl fullWidth>
                                            <Typography id="label" variant="caption" style={{ fontSize: '0.875rem' }}><strong>Workflow: </strong>{rowData?.workflowName}</Typography>
                                        </FormControl>
                                    </div>
                                </div>
                                <div className='form-group'>
                                     <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                         <FormControl fullWidth>
                                            <Typography id="label" variant="caption" style={{ fontSize: '0.875rem' }}><strong>Queue: </strong>{rowData?.departmentName || rowData?.queue}</Typography>
                                        </FormControl>
                                    </div>
                                </div>
                            </div>
                              <div className='form-row' style={{padding: '10px'}}>
                                <div className='form-group'>
                                     <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                         <FormControl fullWidth>
                                            <Typography id="label" variant="caption" style={{ fontSize: '0.875rem' }}><strong>Date Entered Queue: </strong>{rowData?.actionDueDate ||rowData?.dateEnteredQueue}</Typography>
                                        </FormControl>
                                    </div>
                                </div>
                                 <div className='form-group'>
                                     <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                         <FormControl fullWidth>
                                            <Typography id="label" variant="caption" style={{ fontSize: '0.875rem' }}><strong>Days in Queue: </strong>{rowData?.actionAdherence || rowData?.daysInQueue}</Typography>
                                        </FormControl>
                                    </div>
                                </div>
                            </div>
                              <div className='form-row' style={{padding: '10px'}}>
                                <div className='form-group'>
                                     <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                         <FormControl fullWidth>
                                            <Typography id="label" variant="caption" style={{ fontSize: '0.875rem' }}><strong>Time allowed in Queue: </strong>{rowData?.timeAllowedInQueue}</Typography>
                                        </FormControl>
                                    </div>

                                </div>
                                <div className='form-group'>
                                     <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                         <FormControl fullWidth>
                                            <Typography id="label" variant="caption" style={{ fontSize: '0.875rem' }}><strong>Worked On Time (Y/N): </strong>{rowData?.workedOnTime}</Typography>
                                        </FormControl>
                                    </div>
                                    
                                </div>
                            </div>
                              <div className='form-row' style={{padding: '10px'}}>
                                <div className='form-group'>
                                     <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                         <FormControl fullWidth>
                                            <Typography id="label" variant="caption" style={{ fontSize: '0.875rem' }}><strong>Action Started: </strong>{rowData?.activityStartTS || rowData?.actionStarted}</Typography>
                                        </FormControl>
                                    </div>

                                </div>
                                 <div className='form-group'>
                                     <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                         <FormControl fullWidth>
                                            <Typography id="label" variant="caption" style={{ fontSize: '0.875rem' }}><strong>Action Completed: </strong>{rowData?.lastActionDate || rowData?.actionCompleted}</Typography>
                                        </FormControl>
                                    </div>
                                </div>
                            </div>
                              <div className='form-row' style={{padding: '10px'}}>
                                <div className='form-group'>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                         <FormControl fullWidth>
                                            <Typography id="label" variant="caption" style={{ fontSize: '0.875rem' }}><strong>Task Work Item: </strong>{rowData?.workTime || rowData?.taskWorkTime}</Typography>
                                        </FormControl>
                                    </div>
                                </div>
                                 <div className='form-group'>
                                     <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                         <FormControl fullWidth>
                                            <Typography id="label" variant="caption" style={{ fontSize: '0.875rem' }}><strong>Standard Time: </strong>{rowData?.standardTotalTimeDisplay ||rowData?.stdTime}</Typography>
                                        </FormControl>
                                    </div>
                                </div>
                            </div>
                              <div className='form-row' style={{padding: '10px'}}>
                                <div className='form-group'>
                                     <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                         <FormControl fullWidth>
                                            <Typography id="label" variant="caption" style={{ fontSize: '0.875rem' }}><strong>Variance Time: </strong>{formatVarianceTimeDisplay(rowData?.variance ?? rowData?.varianceTime)}</Typography>
                                        </FormControl>
                                    </div>
                                </div>
                                 <div className='form-group'>
                                     <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                         <FormControl fullWidth>
                                            <Typography id="label" variant="caption" style={{ fontSize: '0.875rem' }}><strong>Variance %: </strong>{formatVarianceDisplay(rowData?.variancePercentage ?? rowData?.variancePercent)}</Typography>
                                        </FormControl>
                                    </div>
                                </div>
                            </div>
                            <div className='form-row' style={{padding: '10px'}}>
                                <div className='form-group'>
                                     <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                         <FormControl fullWidth>
                                            <Typography id="label" variant="caption" style={{ fontSize: '0.875rem' }}><strong>Action By: </strong>{rowData?.lastActionUser ||rowData?.actionBy}</Typography>
                                        </FormControl>
                                    </div>

                                </div>
                                 <div className='form-group'>
                                     <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                         <FormControl fullWidth>
                                            <Typography id="label" variant="caption" style={{ fontSize: '0.875rem' }}><strong>Supervisor: </strong>{rowData?.supervisor}</Typography>
                                        </FormControl>
                                    </div>
                                </div>
                            </div>
                            <div className='form-row' style={{padding: '10px'}}>
                                <div className='form-group'>
                                    <div className="col-12 mb-3 align-items-center justify-center">
                                    <TextAreaWithCount
                                    //   ref={noteForActionRef}
                                        id="noteForActionTxt"
                                        nameForField="noteForActionTxt"
                                        labelValue="Y-Trac Note for Action Taken"
                                        readOnly={true}
                                        value = {rowData?.tracNote}
                                        placeholder=""
                                    />
                                    </div>
                                </div>
                            </div>
                            <div className='form-row' style={{padding: '10px'}}>
                                <div className='form-group'>
                                
                                    <div className="col-12 mb-3 align-items-center justify-center">
                                    <TextAreaWithCount
                                    //   ref={narrativeForStateRef}
                                        id="narrativeForStateTxt"
                                        nameForField="narrativeForStateTxt"
                                        labelValue="Narrative for State System"
                                        readOnly={true}
                                        placeholder=""
                                        value={rowData?.mainframeNarrative}
                                        showCopyButton={true}
                                    />
                                    </div>
                                </div>
                            </div>
                            <div className='form-row' style={{padding: '10px'}}>
                                <div className='form-group'>
                                     <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                         <FormControl fullWidth>
                                            <Typography id="label" variant="caption" style={{ fontSize: '0.875rem' }}><strong>QA Results: </strong>{rowData?.qADispositionTypeName || rowData?.qaResult}</Typography>
                                        </FormControl>
                                    </div>

                                </div>
                                 <div className='form-group'>
                                     <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                         <FormControl fullWidth>
                                            <Typography id="label" variant="caption" style={{ fontSize: '0.875rem' }}><strong>QA'd By: </strong>{rowData?.qAUserName || rowData?.qaBy}</Typography>
                                        </FormControl>
                                    </div>
                                </div>
                            </div>
                            <div className='form-row' style={{padding: '10px'}}>
                                <div className='form-group'>
                                     <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                         <FormControl fullWidth>
                                            <Typography id="label" variant="caption" style={{ fontSize: '0.875rem' }}><strong>QA Date: </strong>{rowData?.qADispositionTS || rowData?.qaDate}</Typography>
                                        </FormControl>
                                    </div>

                                </div>
                                 <div className='form-group'>
                                </div>
                            </div>
                            <div className='form-row' style={{padding: '10px'}}>
                                <div className='form-group'>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <TextAreaWithCount
                                    //   ref={noteForActionRef}
                                        id="qaNoteTxt"
                                        nameForField="qaNoteTxt"
                                        labelValue="QA Note:"
                                        readOnly={true}
                                        value={rowData?.qaNote}
                                        placeholder=""
                                    />
                                    </div>
                                </div>
                            </div>

                        </form>
                    </div>
                </div>
                </div>
            </div>
            </div>
            </div>
        </div>
    );
 const rightPaneContent = (
    <div style={{ width: '100%', height: '100%' }}>
        <CaseInformationPane
            ref={caseInfoRef}
            caseNumber={rowData?.caseNumber}
            pageName="Action Taken Details"
        />
    </div>
    );

    return (
        <div>
        <ToggleSplitPane
            leftPaneVisibility={true}
            leftPaneTitle={leftPaneTitle}
            leftPaneContent={leftPaneContent}
            rightPaneTitle={rightPaneTitle}
                rightPaneContent={rightPaneContent}
            leftPaneSize='50%'
        >
        </ToggleSplitPane>

        </div>
    );
 }

export default ActionTakenDetails;